import { Box, Chip, Stack, Tooltip, Typography } from "@mui/material";
import { identificarAmbiente } from "../../shared/ambiente";
import useSessao from "../../shared/useSessao";

export default function IdentificacaoSessao({ compacta = false }) {
  const { user, authenticated } = useSessao();
  const nome = authenticated ? user?.name : "Sessão não autenticada";
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      sx={{ minWidth: 0, flex: compacta ? 1 : undefined }}
    >
      <Tooltip
        title={user?.username ? `${nome} · ${user.username}` : nome || ""}
      >
        <Box sx={{ minWidth: 0, maxWidth: { xs: 200, sm: 280 } }}>
          <Typography
            component="div"
            variant="caption"
            sx={{ opacity: 0.8, lineHeight: 1.2 }}
          >
            Usuário
          </Typography>
          <Typography
            component="div"
            variant="body2"
            noWrap
            sx={{ fontWeight: 500 }}
            title={nome}
          >
            {nome}
          </Typography>
        </Box>
      </Tooltip>
      <Chip
        label={identificarAmbiente()}
        size="small"
        aria-label={`Ambiente: ${identificarAmbiente()}`}
        sx={{
          color: "inherit",
          bgcolor: "rgba(127, 127, 127, 0.18)",
          fontWeight: 600,
          flexShrink: 0
        }}
      />
    </Stack>
  );
}
